module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.introClose) ? _c('LessonHeader', {
    staticClass: "lessonOnTop",
    attrs: {
      "outerData": _vm.lesson ? _vm.lesson.name : ''
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.lesson) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "top": "0",
      "left": "0",
      "z-index": "10000",
      "background-color": "white",
      "transtition": "1s"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto",
      "height": "100%",
      "width": "100%",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "animation": "wiggle 1.5s infinite",
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "src": "https://uploads-ssl.webflow.com/63377a4edcea6933891249a2/63377d0fd67f06ef48eef306_MORIEL%20ENGLISH%20LOGO.svg"
    }
  })])]) : _vm._e()]), _vm._v(" "), (_vm.intro) ? _c('OnBoardingModal', {
    attrs: {
      "text": _vm.intro_text,
      "audioSrc": _vm.intro_audio,
      "imgSrc": _vm.intro_image,
      "vidSrc": _vm.intro_video,
      "type": "lesson",
      "id": _vm.id
    },
    on: {
      "clicked": _vm.clicked
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lesson && _vm.introClose) ? _c('div', [(!_vm.lesson.game) ? _c('Lesson', {
    attrs: {
      "data": _vm.lesson
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lesson.game &&
    (_vm.lesson.game.game_type === 'half' ||
      _vm.lesson.game.game_type === 'full')
  ) ? _c('WordGame', {
    attrs: {
      "data": _vm.lesson,
      "type": _vm.lesson.game.game_type
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lesson.game && _vm.lesson.game.game_type === 'grammar') ? _c('GrammarGame', {
    attrs: {
      "data": _vm.lesson
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lesson.game && _vm.lesson.game.game_type === 'sentence') ? _c('EnglishSen', {
    attrs: {
      "data": _vm.lesson
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-072f27e3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lesson/lesson.vue
// module id = 559
// module chunks = 1